import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';
import TemplateListPanel from '../TemplateListPanel';

const ArchivedTemplatesListPanel = () => {
  const dispatch = useDispatch();

  const { data: requirementTemplates, ...pageInfo } = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplates);

  const fetchNext = () => {
    dispatch(globalRequirementTemplateBuilder.listArchivedRequirementTemplates({
      pageNumber: pageInfo.currentPage + 1,
      pageSize: 25
    }));
  };

  useEffect(() => {
    dispatch(globalRequirementTemplateBuilder.listArchivedRequirementTemplates());
  }, []);

  return (
    <TemplateListPanel
      archived
      fetchNext={fetchNext}
      pageInfo={pageInfo}
      templates={requirementTemplates}
    />
  );
};

export default ArchivedTemplatesListPanel;
